module.exports = __webpack_public_path__ + "media/images/open-icon-27f97bb95341b1b1e7f75ae2e1ecaf1d.png";